module.exports = __webpack_public_path__ + "img/1554713233.226c6b0d.jpg";